var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.bgImg),expression:"$store.state.bgImg"}],staticClass:"backImg"},[_c('img',{style:('height:'+ _vm.height),attrs:{"src":require("@/assets/index/bgImg.jpg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }